"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BundleRequest = void 0;
/**
 * Additional information about how this entry should be processed as part of a transaction or batch.  For history, it shows how the entry was processed to create the version contained in the entry.
 */
var BundleRequest = /** @class */ (function () {
    function BundleRequest() {
    }
    return BundleRequest;
}());
exports.BundleRequest = BundleRequest;
